"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadGroupCalculators = loadGroupCalculators;
const app_1 = require("@kalkulacka-one/app");
async function loadGroupCalculators({ endpoint, group, keys }) {
    const entries = await Promise.all(keys.map(async (key) => {
        try {
            return [key, await (0, app_1.loadCalculator)({ endpoint, key, group })];
        }
        catch (error) {
            if (!(error instanceof app_1.NotFoundError))
                console.error(`Calculator \`${group}/${key}\` could not be loaded`, error);
            return undefined;
        }
    }));
    return Object.fromEntries(entries.filter((entry) => entry !== undefined));
}
